@include host-component-properties;

:host {
  --paf-icon-size-level-2: 24;
  --paf-icon-picto-level-1-size: 20;
  --paf-icon-picto-level-2-size: var(--paf-icon-size-level-2);
  --paf-icon-him-cus-info-size: 32;
  --paf-icon-him-cus-level-1-size: 16;
  --paf-icon-him-cus-level-2-size: var(--paf-icon-size-level-2);
  --paf-icon-attributes-level-2-height: 16;
  --paf-icon-attributes-level-1-height: 20;
  --paf-icon-attributes-level-1-height-mobile: var(--paf-icon-attributes-level-2-height);
  --paf-icon-product-level-1-height: 20;
  --paf-icon-product-level-1-width: 59;
  --paf-icon-product-level-1-aspect-ratio: 59/20;
  --paf-icon-product-level-2-height: 24;
  --paf-icon-product-level-2-width: 71;
  --paf-icon-product-level-2-aspect-ratio: 71/24;

  @include mq($from: small) {
    --paf-icon-him-cus-level-1-size: 20;
    --paf-icon-picto-level-1-size: 28;
    --paf-icon-product-level-1-height: 28;
    --paf-icon-product-level-1-width: 83;
    --paf-icon-product-level-1-aspect-ratio: 83/28;
  }
}

img {
  display: flex;
  pointer-events: none;
  aspect-ratio: var(--paf-icon-aspect-ratio, 1 / 1);
  width: px-to-rem(#{(var(--paf-icon-width, auto))});
  height: px-to-rem(#{(var(--paf-icon-height, auto))});
}

.attribute {
  --paf-icon-height: var(--paf-icon-attributes-height);
}

.cus-him-info {
  --paf-icon-width: var(--paf-icon-him-cus-info-size);
  --paf-icon-height: var(--paf-icon-him-cus-info-size);
}

.cus-him-l1 {
  --paf-icon-width: var(--paf-icon-him-cus-level-1-size);
  --paf-icon-height: var(--paf-icon-him-cus-level-1-size);
}

.cus-him-l2 {
  --paf-icon-width: var(--paf-icon-him-cus-level-2-size);
  --paf-icon-height: var(--paf-icon-him-cus-level-2-size);
}

.picto-l1 {
  --paf-icon-width: var(--paf-icon-picto-level-1-size);
  --paf-icon-height: var(--paf-icon-picto-level-1-size);
}

.picto-l2 {
  --paf-icon-width: var(--paf-icon-picto-level-2-size);
  --paf-icon-height: var(--paf-icon-picto-level-2-size);
}

.product-l1 {
  --paf-icon-aspect-ratio: var(--paf-icon-product-level-1-aspect-ratio);
  --paf-icon-width: var(--paf-icon-product-level-1-width);
  --paf-icon-height: var(--paf-icon-product-level-1-height);
}

.product-l2 {
  --paf-icon-aspect-ratio: var(--paf-icon-product-level-2-aspect-ratio);
  --paf-icon-width: var(--paf-icon-product-level-2-width);
  --paf-icon-height: var(--paf-icon-product-level-2-height);
}

.wheelchair {
  --paf-icon-aspect-ratio: var(--paf-icon-product-aspect-ratio);
  --paf-icon-width: var(--paf-icon-size-level-2);
  --paf-icon-height: var(--paf-icon-size-level-2);
}
